import Vue from 'vue'
import App from './App.vue'
import { router } from '@/router/index.js'
import axios from 'axios'
import ElementUI from 'element-ui'
import dayjs from 'dayjs'
import VueRouter from 'vue-router'
// import 'element-ui/lib/theme-chalk/display.css';
import 'element-ui/lib/theme-chalk/index.css';

// 解决vue弹窗显示会有滚动条问题
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.prototype.noScroll = function () {
  document.body.style.overflow = 'hidden'
  document.addEventListener('touchmove', e => e.preventDefault(), { passive: false })
}

Vue.prototype.canScroll = function () {
  document.body.style.overflow = ''
  document.removeEventListener('touchmove', e => e.preventDefault(), { passive: false })
}

Vue.prototype.$message = ElementUI.Message
Vue.prototype.$dayjs = dayjs

// axios实例
Vue.prototype.$http = axios.create({
  timeout: 6000000,
})

Vue.prototype.$http.interceptors.request.use(config => config, error => Promise.reject(error))

Vue.prototype.$http.interceptors.response.use(
  response => response.data,
  error => {
    if (error.message.includes('timeout')) {
      Vue.prototype.$message.error('网络超时，请联系管理员!')
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

